module.exports = __webpack_public_path__ + "img/sosyalalan.6974c1c5.jpeg";